import React from "react";

const Blur = ({ children, style, blurAmount = 10, text, innerMargin = 0, align = "left" }) => {

  let left, transform;
  switch (align) {
    case "left":
      left = "0%";
      transform = "translate(0, -50%)";
      break;
    case "right":
      left = "100%";
      transform = "translate(-100%, -50%)";
      break;
    default:
      left = "50%";
      transform = "translate(-50%, -50%)";
  }

  return (
    <div
      style={{
        position: "relative",
        ...style
      }}
    >
      {text && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left,
            transform,
            zIndex: 2,
            fontSize: "12px",
            fontWeight: "bold",
            color: "#004F64",
            textAlign: align,
            lineHeight: 2,
            padding: align === "center" ? "0px" : "10px",
            width: align === "center" ? "auto" : "100%"
          }}
        >
          {text}
        </div>
      )}

      {/* Render the children */}
      {children}

      {/* Apply the blur effect */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          backdropFilter: `blur(${blurAmount}px)`,
          zIndex: 1, // Ensure the blur is below the text
          margin: innerMargin
        }}
      />
    </div>
  );
};

export { Blur };
